import { Box, Button, Grid, Typography, styled } from "@mui/material";

export const SubTitle = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  [theme.breakpoints.down("md")]: {
    fontSize: "11px",
  },
}));

export const BtnHeader = styled(Button)({
  textDecoration: "underline",
  color: "#387E3A",
  marginTop: "3px",
  padding: "0px",
});
export const BtnHistory = styled(Button)({
  marginTop: "8px",
  height: "30px",
  fontWeight: "8px",
  fontSize: "12px",
  textTransform: "none",
});
export const BtnBack = styled(Button)({
  textTransform: "none",
  padding: "0px",
  float: "right",
  marginTop: "10px",
  color: "#387E3A",
  size: "12px",
  textDecoration: "underline",
});
export const BtnQuote = styled(Button)({
  marginTop: "10px",
  color: "white",
  background: "#707070 !important",
  textTransform: "none",
});
export const GridBox = styled(Grid)({
  display: "grid",
  gridTemplateColumns: "20% 40% 40%",
  backgroundColor: "#F5FFF6",
  borderRadius: "10px",
  marginRight: "10px",
  height: "130px",
  marginBottom: "10px",
});
export const ClickAreaBox = styled(Box)({
  backgroundColor: "#F5FFF6",
  marginRight: "5px",
  borderRadius: "10px",
});

export const HeadBox = styled(Box)({
  padding: "16px 8px",
  display: "grid",
  gridTemplateColumns: "3% 3% 21% 10% 10% 14% 10% 10% 10% 10%",
  borderRadius: "8px",
  background: "#4daf51",
  color: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
});
export const RowBox = styled(Box)({
  padding: "16px 8px",
  display: "grid",
  gridTemplateColumns: "3% 3% 21% 10% 10% 15% 10% 10% 13% 3%",
  borderRadius: "8px",
  background: "#4daf51",
  color: "white",
  boxShadow: "0px 3px 6px #c2c1c1",
  margin: "8px 0",
  alignItems: "center",
  background: "white",
  color: "black",
});
